<template>
  <a-form>
    <a-form-item label="优惠券名称" required>
      <a-input class="width90" v-model:value="couponForm.coupon_name" @blur="changeCouponName" />
    </a-form-item>
    <a-form-item label="优惠券" required>
      <a-button type="primary" @click="showRed=true" class="m-r-10">选择</a-button>
      <a-button @click="showLogs=true">已选明细</a-button>
    </a-form-item>
  </a-form>
  <a-modal :keyboard="false" title="选择优惠券" v-model:visible="showRed" centered :width='1200' :footer="null" destroyOnClose>
    <selectCoupon :needNum="true" v-on:select="redSelect"  :selectList="couponForm.coupon_content" :checkout='true'></selectCoupon>
  </a-modal>
  <a-modal :keyboard="false" title="已选优惠券" v-model:visible="showLogs" centered :width='1200' :footer="null" destroyOnClose>
    <a-table :pagination='false' bordered :columns='columns' :data-source='couponForm.coupon_content' :scroll="{ x: 'max-content'}">
        <template v-slot:coupon_num="{ record }">
           <a-input-number v-model:value="record.coupon_num" :min="1" :precision="0"></a-input-number>
        </template>
         <template v-slot:action="{ index }">
            <a-button type="danger" size="small" href="javascript:;" @click="delCoupon(index)">删除</a-button>
        </template>
    
    </a-table>
  </a-modal>
</template>
<script>
import { onMounted, ref } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
const columns = [
  {
    title: "卡券ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "优惠",
    key: "amount_text",
    dataIndex: "amount_text",
    align: "center",
    slots: { customRender: "amount_text" },
  },
  {
    title: "券类型",
    dataIndex: "coupon_type_text",
    key: "coupon_type_text",
  },
  {
    title: "有效期",
    key: "valid_period_time",
    dataIndex: "valid_period_time",
  },
   {
    title: "数量",
    key: "coupon_num",
    slots: { customRender: "coupon_num" },
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  name: "isBonus",
  props: {
    couponName: String,
    content: String,
  },
  setup(props, { emit }) {
    const couponForm = ref({});
    const onchange = (e) => {
      emit("update:content", e);
    };
    onMounted(() => {
      console.log(props,'-')
      if(props.content){
         var content=props.content.map(v=>{
          if(!v.coupon_num){
              v['coupon_num']=1
          }
          return v
        })
      }
      couponForm.value = {
          coupon_name: props.couponName,
          coupon_content:content,
        };
    });

    const showRed = ref(false);
    const redSelect = (data) => {
      var couponList=data.map(v=>{
        if(!v.coupon_num){
            v['coupon_num']=1
        }
        return v
      })
      onchange(couponList);
      showRed.value = false;
      couponForm.value.coupon_content = couponList;
    };
    // 修改优惠券名称
    const changeCouponName = () => {
      emit("update:couponName", couponForm.value.coupon_name);
    };
    // 展示 已选明细
    const showLogs = ref(false);
    // 删除优惠券
    const delCoupon=(index)=>{
        couponForm.value.coupon_content.splice(index,1)
        
        onchange(couponForm.value.coupon_content)
    }
    return {
      couponForm,
      onchange,
      showRed,
      changeCouponName,
      redSelect,
      showLogs,
      columns,
      delCoupon
    };
  },
};
</script>